import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';
import { passwordStrengthValidator } from 'src/app/shared/validators/password-strength.validator';
import { BaseComponent } from './../../../core/components/base/base.component';
import { FeedbackService } from './../../../core/services/feedback.service';
import { redirectToLogin } from '../../../core/utils/login-redirect.util';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {

  resetPasswordForm: FormGroup;
  resetToken!: string;
  /** A first password for an account made for a practice, rather than a reset. */
  setup = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, passwordStrengthValidator()]],
      confirmPassword: ['', Validators.required]
    }, { validator: this.passwordMatchValidator });
  }

  ngOnInit() {
    this.resetToken = this.route.snapshot.paramMap.get('token') as string;
    this.setup = this.route.snapshot.data['setup'] === true;
  }

  get passwordStrength() {
    const password = this.resetPasswordForm.get('password')?.value;
    if (password) {
      return this.userService.calculateStrength(password);
    }
    return 0;
  }

  onSubmit() {
    if (this.resetPasswordForm.valid) {
      const { password } = this.resetPasswordForm.value;
      const sub = this.userService.resetPassword(this.resetToken, password)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response) => {
            if (response.success) {
              // Password reset successful
              this.showToastMessage(response.message);
              // One navigation to a freshly loaded /login — see `redirectToLogin`.
              redirectToLogin();
            } else {
              // Password reset failed
              this.showToastMessage(response.message);
            }
            sub.unsubscribe();
          },
          (error) => {
            this.showToastMessage(error.error.message);
            sub.unsubscribe();
          }
        );
    }
  }

  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password')!.value;
    const confirmPassword = formGroup.get('confirmPassword')!.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }


}